import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/debounceTime';
import { FormControl } from '@angular/forms'
import { UserAccountApi, SectorCategoryApi, InstitutionsApi } from '../../../../../../theme/services/sdk';
import {BaToastNotificationService} from '../../../../../../theme/services/baToastNotification';
import { SectorCategoriesComponent } from "../../sector-categories.component";

@Component({
  selector: 'sector-category-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  providers:[UserAccountApi, SectorCategoryApi, InstitutionsApi]
})
export class SectorCategoryList {

  sector_category_list:Object;
  edited_id:number;

  /* pagination */
  p: number; // set first page to 1
  itemsPerPage: number; // number of items per page
  totalItems: number; // total items in the database

  //search
  searching: boolean;
  term = new FormControl();

  constructor(protected user:UserAccountApi, protected sectorCategory:SectorCategoryApi, protected institution: InstitutionsApi, private route: ActivatedRoute, private router: Router,private toast: BaToastNotificationService,private data: SectorCategoriesComponent) {
    this.user.isAuthenticated() ? false : this.router.navigate(['login']);
  }

  ngOnInit() {
    this.data.sector_categories.subscribe(data => this.sector_category_list = data);
    this.data.total_items.subscribe(data => this.totalItems = data);
    this.data.searching.subscribe(data => this.searching = data);
    this.data.p.subscribe(data => this.p = data);
    this.data.itemsPerPage.subscribe(data => this.itemsPerPage = data);
    this.data.editedId.subscribe(data=>this.edited_id=data);
    this.searchInputChange();
  }

  searchInputChange() {
    this.term.valueChanges
        .debounceTime(400)
        .subscribe( term => {
          if(term){
            this.searching = true;
            this.data.search(term,this.p);
          }
          else{
            this.p = 1; //reset page
            this.data.getCount();
            this.data.getSectorCategories(this.p);
          }
        });
  }

  pageChanged(page: number) {
    this.p = page;
    if (this.term.value)
      this.data.search(this.term.value, page);
    else
      this.data.getSectorCategories(page);
  }

  parseSelected(data){
    this.data.updateSectorCategorySource(data);
  }

  cancelSelected(){
    this.data.cancelSelected();
  }

  deleteRecord(data) {
    if(confirm("Are you sure to delete >> "+data.name)) {
      this.institution.count({sector_category_id:data.id})
          .subscribe(res=>{
            if(res.count){
              this.toast.warning({
                heading: 'Warning',
                text: 'Record cannot be deleted since it\'s in use',
                stack: 3
              });
            }else {
              this.sectorCategory.deleteById(data.id)
                  .subscribe(res=>{
                    this.toast.success({
                      heading: 'Warning',
                      text: `Record '${data.name}' has successfully been deleted`,
                      stack: 3
                    });
                    this.data.refresh();//reset page
                  },err=>{
                    this.toast.error({
                      heading: 'Error',
                      text: 'Something went wrong. Reload to try again.',
                      stack: 3
                    });
                  })
            }
          },err=>{
            this.toast.error({
              heading: 'Error',
              text: 'Something went wrong. Reload to try again.',
              stack: 3
            });
          })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sector-categories/components/list/list.component.ts